import { DirectionType } from "./types";
import { InfoTextContainer } from "./InfoTextContainer";

interface InfoTextProps {
  readonly type: DirectionType;
  readonly text: string;
  readonly elementWidth: number;
  readonly units: string;
}

export function InfoText({ text, type, elementWidth, units }: InfoTextProps) {
  return (
    <div
      className={`sticky right-0 left-0 ml-auto w-max font-default text-s ${type === "arrive" ? "inline-block" : "block"}`}
    >
      <InfoTextContainer type={type} maxWidth={elementWidth}>
        <span className="overflow-hidden text-ellipsis whitespace-nowrap">{text}</span>
        <span className="text-xs text-subtle">{units}</span>
      </InfoTextContainer>
    </div>
  );
}
